const routes = [{
        // 综合
        path: '/situation/composite',
        name: 'composite',
        component: () => import('./view/composite.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        // 人员类型统计
        path: '/situation/PersonType',
        name: 'personType',
        component: () => import('./view/PersonType.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        // 冷库
        path: '/situation/coldStorage',
        name: 'coldStorage',
        component: () => import('./view/coldStorage.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        // 能耗
        path: '/situation/power',
        name: 'power',
        component: () => import('./view/power.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        // 安防
        path: '/situation/security',
        name: 'security',
        component: () => import('./view/Security.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        //设施
        path: '/situation/plant',
        name: 'plant',
        component: () => import('./view/plant.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },

    {
        //调度
        path: '/situation/dispatch',
        name: 'plant',
        component: () => import('./view/Dispatch.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    }, {
        //车辆
        path: '/situation/car',
        name: 'car',
        component: () => import('./view/car.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        //零碳主题
        path: '/situation/carbon',
        name: 'carbon',
        component: () => import('./view/carbon.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        //月台
        path: '/situation/platform',
        name: 'plant',
        component: () => import('./view/Platform.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    },
    {
        //应急
        path: '/situation/emergency',
        name: 'plant',
        component: () => import('./view/Emergency.vue'),
        meta: {
            requireAuth: false,
            routerAlive: false
        }
    }

]
export default routes